import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DashboardHeader = ({ coachName, canCreateNew, onLogout }) => {
  const navigate = useNavigate();

  const handleNewRegistration = async () => {
    // Clear any existing session draft state before navigating
    sessionStorage.removeItem('currentDraftId');
    // Pass flag to indicate this is a new registration
    navigate('/team-registration-form', { state: { isNewRegistration: true } });
  };

  return (
    <div className="card">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 lg:w-16 lg:h-16 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="User" size={28} color="var(--color-primary)" />
          </div>
          <div>
            <h1 className="text-xl lg:text-2xl font-bold text-foreground">
              Welcome back, {coachName}!
            </h1>
            <p className="text-sm text-muted-foreground">
              Manage your MI Junior Cricket Tournament registrations
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          <Button
            variant="outline"
            size="default"
            iconName="LogOut"
            iconPosition="left"
            onClick={onLogout}
            className="w-full sm:w-auto"
          >
            <span className="hidden sm:inline">Logout</span>
            <span className="sm:hidden">Logout</span>
          </Button>
          <Button
            variant="default"
            size="default"
            iconName="Plus"
            iconPosition="left"
            onClick={handleNewRegistration}
            disabled={!canCreateNew}
            className="w-full sm:w-auto"
          >
            <span className="hidden sm:inline">New Registration</span>
            <span className="sm:hidden">New</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;